/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Internal development status of a ticket. Hidden from most users (support-only);
 * see !:Compliance.Module.Support.DbModels.SupportTicket.DevelopmentStatus.
 */
export enum SupportDevelopmentStatus {
    DRAFT = 'Draft',
    NEW = 'New',
    REVIEWED = 'Reviewed',
    APPROVED = 'Approved',
    IN_DEVELOPMENT = 'InDevelopment',
    IN_TEST = 'InTest',
    ON_UAT = 'OnUat',
    TESTED_ON_UAT = 'TestedOnUat',
    COMPLETED = 'Completed',
    CANCELLED = 'Cancelled',
}
